import React, {useState, useEffect} from 'react';
import './HamburgerMenu.scss';
import {Link} from 'react-router-dom';
import { multiSitePages } from '.';
// const multiLocationPages = [
//     // {'path': '/our-story', 'name': 'Our Story'},
//     // {'path': '/catering', 'name': 'Catering'},
//     // {'path': '/locations', 'name': 'Locations'},
//     // {'path': '/contact-us', 'name': 'Contact Us'},
//     // {'path': '/wholesale', 'name': 'Wholesale'},
   
//     {'path': '/glendale', 'name': 'Glendale Menu'},
//     {'path': '/glendale/order', 'name': 'Glendale Ordering (Pickup/Delivery)'},
//     // {'path': '/noho', 'name': 'North Hollywood Menu'},
//     // {'path': '/noho', 'name': 'North Hollywood Ordering (Pickup/Delivery)'},
//     // {'path': '/shermanoaks', 'name': 'Order Online'},
//     // {'path': '/gift-cards', 'name': 'Gift Cards'},
//     // {'path': '/events', 'name': 'Events'},
//   ]

export default function HamburgerMenu() {
    const [showMenu, setShowMenu] = useState(false)
    useEffect(() => {
        const handleKeyDown = (e) => {
          if (e.key === 'Escape') {
            setShowMenu(false);
          }
        };
      
        if (showMenu) {
          document.addEventListener('keydown', handleKeyDown);
        } else {
          document.removeEventListener('keydown', handleKeyDown);
        }
      
        return () => {
          document.removeEventListener('keydown', handleKeyDown);
        };
      }, [showMenu]);
    function toggleMenu() {
        setShowMenu(!showMenu)
    }
    function handleClickOverlay () {
        setShowMenu(false)
    }
    return(
        <div className="hamburger-nav">
            <span onClick={toggleMenu} className="hamburger-icon">
               <HamburgerSVG />
                {/* <img src="https://afag.imgix.net/jojos-mediterranean-grill/hamburger.png?w=150&auto=format" alt="show site navigation" /> */}
            </span>


            {showMenu ? <div onClick={handleClickOverlay} className="overlay-menu-content">
                {multiSitePages.map((item, index) => {
                    return (
                        <div key={index} className="hamburger-nav-item">
                            <Link to={item.path} onClick={toggleMenu}>{item.label}</Link>
                        </div>
                    )
                })}
            </div> : null}
        </div>
    )
}



const HamburgerSVG = (props) => (
  <svg className="hamburger-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 77.3 67.6" {...props}>
    <path 
    
    d="M73.4 37.6H3.8c-2.1 0-3.8-1.7-3.8-3.8C0 31.7 1.7 30 3.8 30h69.7c2.1 0 3.8 1.7 3.8 3.8 0 2.1-1.7 3.8-3.9 3.8ZM73.4 7.6H3.8C1.7 7.6 0 5.9 0 3.8 0 1.7 1.7 0 3.8 0h69.7c2.1 0 3.8 1.7 3.8 3.8 0 2.1-1.7 3.8-3.9 3.8ZM73.4 67.6H3.8c-2.1 0-3.8-1.7-3.8-3.8C0 61.7 1.7 60 3.8 60h69.7c2.1 0 3.8 1.7 3.8 3.8 0 2.1-1.7 3.8-3.9 3.8Z" />
  </svg>
)
